import script from "./identification-new-user.vue?vue&type=script&lang=ts&setup=true"
export * from "./identification-new-user.vue?vue&type=script&lang=ts&setup=true"

import "./identification-new-user.vue?vue&type=style&index=0&id=09203894&lang=less&scoped=true"

import exportComponent from "D:\\Projects\\aba\\aba-cabinet-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-09203894"]])

export default __exports__